import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'shared/button/button.module';
import { DropdownModule } from 'shared/dropdown/dropdown.module';

import { RadialProgressComponent } from './radial-progress.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    RadialProgressComponent,
  ],
  exports: [
    RadialProgressComponent,
   ],
  providers: []
})
export class RadialProgressModule {}
